import get from 'lodash/get';
import { combineStringsWithSpace } from './utils';

const getPrimaryImageFromCartItem = cartItem => get(cartItem, 'product.imageMetadata');

const getCartItemImage = cartItem => get(getPrimaryImageFromCartItem(cartItem), 'imageLink.fullUri');

const getCartItemImageSmall = (cartItem) => {
    const image = getPrimaryImageFromCartItem(cartItem);
    return `${get(image, 'imageLink.uriBase')}w_250,h_250,c_fit/${get(image, 'imageLink.imagePath')}`;
};

const splitLink = (cloudinaryLink) => {
    if (!cloudinaryLink) return {};

    const splitKey = 'upload/';
    if (!cloudinaryLink.includes(splitKey)) return {};

    const indexOfSplit = cloudinaryLink.indexOf(splitKey) + splitKey.length;
    return {
        uriBase: cloudinaryLink.substring(0, indexOfSplit),
        imagePath: cloudinaryLink.substring(indexOfSplit)
    };
};

const cartItemMapper = (cartItem) => {
    if (cartItem.product) {
        return {
            product_name: cartItem.product.name,
            product_url: cartItem.product.seoFriendlyName,
            product_sku: cartItem.product.sku,
            product_price: cartItem.product.pricing.listPrice,
            product_sale_price: cartItem.product.pricing.salePrice,
            product_variant: cartItem.product.productVariantId,
            product_image_url: getCartItemImage(cartItem),
            product_image_url_sm: getCartItemImageSmall(cartItem),
            product_product_categories: cartItem.product.categoryIds
        };
    }

    const legacyCartItemShape = {
        product: {
            imageMetadata: {
                imageLink: {
                    ...splitLink(cartItem.imageSrc)
                }
            }
        }
    };

    const imageSm = getCartItemImageSmall(legacyCartItemShape);

    return {
        product_name: cartItem.productName,
        product_url: cartItem.seoFriendlyName,
        product_sku: cartItem.sku,
        product_price: cartItem.price.amount / 100,
        product_variant: cartItem.variantId,
        product_image_url: cartItem.imageSrc,
        product_image_url_sm: imageSm,
        product_product_categories: cartItem.categoryIds
    };
};

export const createCartItems = (cartItems = [], productBaseUrl) =>
    cartItems
        .map(cartItemMapper)
        .map(cartItem => ({ ...cartItem, product_url: `${productBaseUrl}/p/${cartItem.product_url}` }));

export const getCartShopperInfo = cart => ({
    email: get(cart, 'contactInfo.email'),
    first_name: get(cart, 'shippingAddress.firstName'),
    last_name: get(cart, 'shippingAddress.lastName'),
    address: combineStringsWithSpace([get(cart, 'shippingAddress.address1'), get(cart, 'shippingAddress.address2')]),
    city: get(cart, 'shippingAddress.city'),
    state: get(cart, 'shippingAddress.state'),
    zip: get(cart, 'shippingAddress.postalCode'),
    country: get(cart, 'shippingAddress.country'),
    phone: get(cart, 'contactInfo.phoneNumber')
});

export const getOrderContactInfo = order => ({
    email: get(order, 'placedBy.emailAddress'),
    first_name: get(order, 'placedBy.firstName'),
    last_name: get(order, 'placedBy.lastName'),
    address: combineStringsWithSpace([
        get(order, 'placedBy.address.address1'),
        get(order, 'placedBy.address.address2')
    ]),
    city: get(order, 'placedBy.address.city'),
    state: get(order, 'placedBy.address.state'),
    zip: get(order, 'placedBy.address.postalCode'),
    country: get(order, 'placedBy.address.country'),
    phone: get(order, 'placedBy.phoneNumber')
});



// WEBPACK FOOTER //
// ./src/app/services/dataLayer/cart.js